import { createFileRoute } from "@tanstack/react-router";
import { CandidateRecord } from "./-components/candidate-record";

export const Route = createFileRoute(
  "/_authenticated/_workforce/hiring/applications/$applicationId",
)({
  component: ApplicationDetail,
});

function ApplicationDetail() {
  const { applicationId } = Route.useParams();
  return <CandidateRecord applicationId={applicationId} />;
}
